import Layout from "../components/Layout";
import { Reveal } from "../components/Reveal";
import { Eyebrow, PageHeader } from "../components/bits";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../data/content";

export default function FAQ() {
  return (
    <Layout>
      <PageHeader
        eyebrow="Frequently asked"
        title="The honest answers."
        subtitle="Including the one everyone asks first: isn't this just a charging pad?"
      />
      <section className="bg-white px-5 pb-28 pt-4 md:px-8">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`f${i}`} className="border-navy/10">
                  <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-lg font-bold text-navy hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base leading-relaxed text-navy/70">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
